import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Megaphone = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g filter="url(#filter0_ii_1097_19248)">
      <mask
        id="mask0_1097_19248"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="19"
        height="18"
      >
        <path
          d="M17 6.33322H13.6833C13.4408 6.31905 9.215 6.02155 5.19083 2.64655C4.99651 2.48334 4.75964 2.37898 4.50806 2.34573C4.25647 2.31247 4.00063 2.3517 3.77057 2.45881C3.54051 2.56592 3.3458 2.73646 3.2093 2.9504C3.0728 3.16433 3.00019 3.41278 3 3.66655V16.9999C3.00003 17.2537 3.07253 17.5023 3.20896 17.7163C3.3454 17.9304 3.5401 18.1011 3.77019 18.2083C4.00028 18.3155 4.25619 18.3548 4.50785 18.3216C4.75951 18.2883 4.99645 18.184 5.19083 18.0207C8.33833 15.3807 11.6075 14.624 13 14.4124V17.0557C12.9997 17.2754 13.0537 17.4918 13.1573 17.6856C13.2608 17.8794 13.4106 18.0446 13.5933 18.1666L14.51 18.7774C14.6872 18.8956 14.8901 18.9697 15.1018 18.9934C15.3135 19.0171 15.5278 18.9898 15.7268 18.9136C15.9257 18.8375 16.1035 18.7148 16.2453 18.5558C16.3871 18.3969 16.4887 18.2062 16.5417 17.9999L17.5225 14.3032C18.5364 14.1786 19.4643 13.6709 20.1158 12.884C20.7673 12.0971 21.093 11.0908 21.0262 10.0714C20.9594 9.05201 20.505 8.09683 19.7564 7.40174C19.0077 6.70665 18.0215 6.32434 17 6.33322ZM15.25 17.6574V17.6666L14.3333 17.0557V14.3332H16.1333L15.25 17.6574ZM17 12.9999H14.3333V7.66655H17C17.7072 7.66655 18.3855 7.9475 18.8856 8.4476C19.3857 8.94769 19.6667 9.62597 19.6667 10.3332C19.6667 11.0405 19.3857 11.7187 18.8856 12.2188C18.3855 12.7189 17.7072 12.9999 17 12.9999Z"
          fill="url(#paint0_linear_1097_19248)"
        />
      </mask>
      <g mask="url(#mask0_1097_19248)">
        <g filter="url(#filter1_n_1097_19248)">
          <mask
            id="mask1_1097_19248"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="57"
            height="21"
          >
            <rect
              x="0.367676"
              y="0.392334"
              width="56.4604"
              height="19.7383"
              fill="#C4C4C4"
            />
          </mask>
          <g mask="url(#mask1_1097_19248)">
            <rect
              x="-2.22021"
              y="0.381836"
              width="61.6359"
              height="20.8554"
              fill="#272727"
            />
            <g filter="url(#filter2_f_1097_19248)">
              <path
                d="M-1.8999 9.08105L29.5496 0.10376H43.8449L61.3395 2.49771L0.00611758 15.8781L-1.8999 9.08105Z"
                fill="url(#paint1_linear_1097_19248)"
              />
            </g>
            <g filter="url(#filter3_f_1097_19248)">
              <path
                d="M-3.59668 8.80605L31.7393 0.378762L43.845 0.10376L61.3396 2.49771L0.0062294 15.8781L-3.59668 8.80605Z"
                fill="url(#paint2_linear_1097_19248)"
              />
            </g>
            <g filter="url(#filter4_f_1097_19248)">
              <ellipse
                cx="12.1868"
                cy="2.62695"
                rx="12.1868"
                ry="2.62695"
                transform="matrix(0.970848 -0.239694 0.53063 0.847603 20.291 7.89355)"
                fill="#FEBC2E"
              />
            </g>
            <g filter="url(#filter5_f_1097_19248)">
              <path
                d="M26.7732 1.03842C19.9138 1.59424 11.358 2.65957 2.94974 1.03842C2.50719 0.9149 2.1679 1.04768 4.35111 2.56693C7.08012 4.466 16.0047 3.67858 26.7732 1.03842Z"
                fill="#B7FEAE"
              />
            </g>
            <g opacity="0.4" filter="url(#filter6_f_1097_19248)">
              <path
                d="M24.2751 1.30139C18.8348 1.74223 12.0489 2.58717 5.3801 1.30139C5.02911 1.20343 4.76001 1.30874 6.49156 2.5137C8.65601 4.0199 15.7343 3.39538 24.2751 1.30139Z"
                fill="#FFEB80"
              />
            </g>
            <g filter="url(#filter7_f_1097_19248)">
              <path
                d="M27.1558 7.5823C40.2938 3.99139 45.7396 3.82039 58.333 5.18836L62.4854 9.80525L1.76463 20.2788C0.652785 20.1648 3.87485 17.2863 12.6563 12.9259C14.3115 12.104 14.0178 11.1732 27.1558 7.5823Z"
                fill="url(#paint3_linear_1097_19248)"
              />
            </g>
            <g opacity="0.7" filter="url(#filter8_f_1097_19248)">
              <path
                d="M35.6154 6.01974C49.0701 2.92573 45.7399 3.82027 58.3333 5.18823L62.4858 9.80512L2.24156 20.1931C1.12971 20.0791 -0.140974 17.6624 3.67109 14.2083C8.43617 9.89062 19.953 9.62143 35.6154 6.01974Z"
                fill="#B7FEAE"
                fillOpacity="0.5"
              />
            </g>
            <g filter="url(#filter9_f_1097_19248)">
              <path
                d="M30.2415 10.2555C45.6241 8.09983 44.8483 6.10885 58.7738 7.47682L60.738 12.0937L-5.87843 22.4817C-7.10788 22.3677 -8.51297 19.951 -4.2977 16.4968C0.971397 12.1792 18.6495 11.8799 30.2415 10.2555Z"
                fill="#EF196E"
              />
            </g>
            <g filter="url(#filter10_f_1097_19248)">
              <ellipse
                cx="12.1868"
                cy="2.62695"
                rx="12.1868"
                ry="2.62695"
                transform="matrix(0.970848 -0.239694 0.53063 0.847603 -2.26953 11.4248)"
                fill="#B7FEAE"
              />
            </g>
            <g opacity="0.4" filter="url(#filter11_f_1097_19248)">
              <ellipse
                cx="12.1868"
                cy="3.81366"
                rx="12.1868"
                ry="3.81366"
                transform="matrix(0.970848 -0.239694 0.53063 0.847603 17.5347 12.679)"
                fill="#FFEB80"
              />
            </g>
            <g filter="url(#filter12_f_1097_19248)">
              <ellipse
                cx="10.951"
                cy="4.04657"
                rx="10.951"
                ry="4.04657"
                transform="matrix(0.970848 -0.239694 0.53063 0.847603 -14.1636 11.542)"
                fill="#04E3BA"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ii_1097_19248"
        x="-0.280904"
        y="-0.212881"
        width="22.4258"
        height="22.3573"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.6144" dy="0.477867" />
        <feGaussianBlur stdDeviation="0.684373" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.717647 0 0 0 0 0.996078 0 0 0 0 0.682353 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1097_19248"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.477867" dy="-0.546133" />
        <feGaussianBlur stdDeviation="1.36021" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0 0.886275 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1097_19248"
          result="effect2_innerShadow_1097_19248"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1097_19248"
        x1="21.846"
        y1="4.87842"
        x2="13.978"
        y2="21.9582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B7FEAE" />
        <stop offset="1" stopColor="#25FBD3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1097_19248"
        x1="29.7198"
        y1="0.10376"
        x2="16.0704"
        y2="20.741"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7D54" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1097_19248"
        x1="20.0196"
        y1="5.70388"
        x2="10.1662"
        y2="20.0548"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0104167" stopColor="#FFEB80" />
        <stop offset="0.458333" stopColor="#274AE2" />
        <stop offset="1" stopColor="#272727" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1097_19248"
        x1="46.0118"
        y1="6.29983"
        x2="22.4918"
        y2="21.3167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B7FEAE" />
        <stop offset="0.65537" stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
      <filter
        id="filter1_n_1097_19248"
        x="0.367676"
        y="0.392334"
        width="56.4604"
        height="19.7383"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="58.59375 58.59375"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="7978"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="shape"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect1_noise_1097_19248">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter2_f_1097_19248"
        x="-2.13884"
        y="-0.135174"
        width="63.7171"
        height="16.2523"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.119467"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter3_f_1097_19248"
        x="-5.81535"
        y="-2.11491"
        width="69.3739"
        height="20.2117"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1.10933"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter4_f_1097_19248"
        x="8.74744"
        y="-9.32873"
        width="49.5383"
        height="33.0557"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="6.42731"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter5_f_1097_19248"
        x="-6.09851"
        y="-7.71789"
        width="41.593"
        height="20.053"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4.36053"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter6_f_1097_19248"
        x="0.754952"
        y="-3.09222"
        width="27.8856"
        height="10.8021"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2.18283"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter7_f_1097_19248"
        x="-0.351417"
        y="2.49233"
        width="64.7414"
        height="19.6911"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.95232"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter8_f_1097_19248"
        x="0.116095"
        y="2.93738"
        width="63.363"
        height="18.249"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.49664"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter9_f_1097_19248"
        x="-107.13"
        y="-92.9729"
        width="267.868"
        height="215.455"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="50"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter10_f_1097_19248"
        x="-8.91839"
        y="-0.902764"
        width="39.7489"
        height="23.2662"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="3.97995"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter11_f_1097_19248"
        x="10.1824"
        y="-0.568802"
        width="42.4149"
        height="27.1183"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="4.60117"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
      <filter
        id="filter12_f_1097_19248"
        x="-22.2954"
        y="-2.03467"
        width="41.8218"
        height="28.7634"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="5.03125"
          result="effect1_foregroundBlur_1097_19248"
        />
      </filter>
    </defs>
  </Svg>
);

export default Megaphone;
